import { render, staticRenderFns } from "./Comparativo.vue?vue&type=template&id=798eb1c1&"
import script from "./Comparativo.vue?vue&type=script&lang=js&"
export * from "./Comparativo.vue?vue&type=script&lang=js&"
import style0 from "./Comparativo.vue?vue&type=style&index=0&id=798eb1c1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports